import { ref, watchEffect } from "vue";

export function awaitPromise<T>(promise: Promise<T>) {
  const result = ref<T | undefined>();
  const loading = ref(true);
  const error = ref(false);

  watchEffect(async () => {
    try {
      result.value = await promise;
      loading.value = false;
    } catch (e) {
      loading.value = false;
      error.value = true;
    }
  });

  return { result, loading, error };
}
